// Permission required by the gateway (KrakenD) for POST /v1/battery-activator.
// The gateway validates it against the JWT `permissions` claim (roles_key: "permissions").
export const REQUIRED_ACTIVATION_PERMISSION = 'BO_BATTERY_WRITE'

// Checks the decoded JWT payload for the activation permission.
// Returns true | false | null — null means "can't tell" (claim missing/malformed),
// in which case callers should fail open and let the gateway be the source of truth.
export function tokenHasActivationPermission(payload) {
  const permissions = payload?.permissions
  if (!Array.isArray(permissions)) return null
  return permissions.includes(REQUIRED_ACTIVATION_PERMISSION)
}
